export const LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_STARTED = "LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_STARTED";
export const LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_SUCCESS = "LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_SUCCESS";
